import script from "./PCDetalleLineaPedidoVenta.vue?vue&type=script&setup=true&lang=js"
export * from "./PCDetalleLineaPedidoVenta.vue?vue&type=script&setup=true&lang=js"

import "./PCDetalleLineaPedidoVenta.vue?vue&type=style&index=0&id=2572f0b9&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2572f0b9"]])

export default __exports__